import ComponentLayout from "../../../../src/layouts/component-layout";
import anatomy from "../../../../content/components/Section/images/anatomy.png";
import * as React from 'react';
export default {
  ComponentLayout,
  anatomy,
  React
};